import i18n from "src/config/i18n";

// 현재 언어 코드 반환 (i18next 기준). react-localization 제거 후 잔존 헬퍼.
export const getLanguage = () => {
  const lang = i18n.language;
  return lang;
};
